import { ConfigurationProfilesWebComponent } from './component/ConfigurationProfilesWebComponent';
import { WEB_COMPONENT_CONFIGURATION_PROFILES } from '../../webcomponents.constants';

/**
 * Page component for Configuration Profiles page
 * @link https://bitdefender.atlassian.net/wiki/spaces/GZDOCS/pages/1153469606/Configuration+Profiles+Page
 */
export { ConfigurationProfilesWebComponent };

window.customElements.define(WEB_COMPONENT_CONFIGURATION_PROFILES, ConfigurationProfilesWebComponent);
